(() => {
  function init(root = document) {
    root.querySelectorAll('[data-astra-home]:not([data-ready])').forEach(home => {
      home.dataset.ready = 'true';
      const tabs = [...home.querySelectorAll('[data-astra-tab]')];
      const panels = [...home.querySelectorAll('[data-astra-panel]')];
      const select = id => {
        tabs.forEach(t => { const active = t.dataset.astraTab === id; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
        panels.forEach(p => { p.hidden = p.dataset.astraPanel !== id; });
      };
      home.querySelector('.astra-tabs')?.setAttribute('role', 'tablist');
      tabs.forEach((t,i) => {
        t.setAttribute('role','tab'); t.id = 'astra-tab-' + t.dataset.astraTab;
        t.setAttribute('aria-controls','astra-panel-' + t.dataset.astraTab);
        t.addEventListener('click', e => { e.preventDefault(); select(t.dataset.astraTab); });
        t.addEventListener('keydown', e => { let n; if(e.key==='ArrowRight') n=(i+1)%tabs.length; if(e.key==='ArrowLeft') n=(i-1+tabs.length)%tabs.length; if(e.key==='Home') n=0; if(e.key==='End') n=tabs.length-1; if(n!==undefined){e.preventDefault();select(tabs[n].dataset.astraTab);tabs[n].focus();} });
      });
      panels.forEach(p => {p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby','astra-tab-'+p.dataset.astraPanel);});
      if(tabs.length) select(tabs[0].dataset.astraTab);
    });
    root.querySelectorAll('[data-astra-explorer]:not([data-ready])').forEach(explorer => {
      explorer.dataset.ready='true';
      explorer.querySelectorAll('[data-astra-photo-button]').forEach(b => b.addEventListener('click', () => {
        explorer.querySelectorAll('[data-astra-photo]').forEach(p => {p.hidden=p.dataset.astraPhoto!==b.dataset.astraPhotoButton;});
        explorer.querySelectorAll('[data-astra-photo-button]').forEach(t => t.setAttribute('aria-pressed',String(t===b)));
      }));
    });
    root.querySelectorAll('[data-astra-inspection]:not([data-ready])').forEach(inspection => {
      inspection.dataset.ready='true';
      const tabs=[...inspection.querySelectorAll('[data-astra-inspection-tab]')];
      const panels=[...inspection.querySelectorAll('[data-astra-inspection-panel]')];
      const images=[...inspection.querySelectorAll('[data-astra-inspection-image]')];
      const select=id => {
        tabs.forEach(tab => {const active=tab.dataset.astraInspectionTab===id;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
        panels.forEach(panel => {panel.hidden=panel.dataset.astraInspectionPanel!==id;});
        images.forEach(image => {image.hidden=image.dataset.astraInspectionImage!==id;});
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click',()=>select(tab.dataset.astraInspectionTab));
        tab.addEventListener('keydown',event => {
          let next;
          if(event.key==='ArrowRight') next=(index+1)%tabs.length;
          if(event.key==='ArrowLeft') next=(index-1+tabs.length)%tabs.length;
          if(event.key==='Home') next=0;
          if(event.key==='End') next=tabs.length-1;
          if(next!==undefined){event.preventDefault();select(tabs[next].dataset.astraInspectionTab);tabs[next].focus();}
        });
      });
    });
    root.querySelectorAll('[data-astra-fit-form]:not([data-ready])').forEach(form => {
      form.dataset.ready='true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const available=Number(new FormData(form).get('room_width'));
        const chair=Number(form.dataset.chairWidth);
        const result=form.parentElement.querySelector('[data-astra-fit-result]');
        if(!result || !available || !chair) return;
        const remaining=Math.round((available-chair)*10)/10;
        result.classList.remove('is-tight','is-short');
        let message='';
        if(remaining<0){
          result.classList.add('is-short');
          message=`Il manque ${Math.abs(remaining).toLocaleString('fr-FR')} cm sur la largeur indiquée. Choisissez un autre emplacement ou un modèle plus compact.`;
        }else if(remaining<20){
          result.classList.add('is-tight');
          message=`Le fauteuil entre sur la largeur, avec ${remaining.toLocaleString('fr-FR')} cm à répartir autour. Vérifiez aussi la profondeur et la zone de bascule.`;
        }else{
          message=`Il reste ${remaining.toLocaleString('fr-FR')} cm à répartir autour du fauteuil. Vérifiez maintenant la profondeur, les passages et la zone de bascule.`;
        }
        result.querySelector('p').textContent=message;
      });
    });
    root.querySelectorAll('[data-astra-motion]:not([data-ready])').forEach(motion => {
      motion.dataset.ready='true';
      const frames=[...motion.querySelectorAll('[data-astra-motion-frame]')];
      const stage=motion.querySelector('[data-astra-motion-stage]');
      const current=motion.querySelector('[data-astra-motion-current]');
      const play=motion.querySelector('[data-astra-motion-play]');
      const rocking=motion.querySelector('[data-astra-rocking-frame]');
      const rockingVideo=motion.querySelector('[data-astra-motion-video]');
      const modeButtons=[...motion.querySelectorAll('[data-astra-motion-mode]')];
      let index=0, timer=null, startX=null;
      const show=next => {
        index=(next+frames.length)%frames.length;
        frames.forEach((frame,i) => {const active=i===index;frame.classList.toggle('is-active',active);frame.setAttribute('aria-hidden',String(!active));});
        if(current) current.textContent=String(index+1).padStart(2,'0');
      };
      const stop=() => {if(timer) clearInterval(timer);timer=null;play?.setAttribute('aria-pressed','false');const label=play?.querySelector('span');if(label)label.textContent='Lancer la séquence';const icon=play?.querySelector('i');if(icon)icon.textContent='▶';};
      const togglePlay=() => {if(timer){stop();return;}play?.setAttribute('aria-pressed','true');const label=play?.querySelector('span');if(label)label.textContent='Mettre en pause';const icon=play?.querySelector('i');if(icon)icon.textContent='Ⅱ';timer=setInterval(()=>show(index+1),1350);};
      const setMode=mode => {
        const isRocking=mode==='rocking' && rocking;
        stop();
        motion.classList.toggle('is-rocking',Boolean(isRocking));
        modeButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.astraMotionMode===mode)));
        frames.forEach((frame,i)=>{frame.hidden=Boolean(isRocking);frame.setAttribute('aria-hidden',String(Boolean(isRocking)||i!==index));});
        if(rocking){rocking.hidden=!isRocking;rocking.setAttribute('aria-hidden',String(!isRocking));}
        if(rockingVideo){
          if(isRocking && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
            rockingVideo.currentTime=0;
            rockingVideo.play().catch(()=>{});
          }else rockingVideo.pause();
        }
        if(stage) stage.setAttribute('aria-label',isRocking?'Visualisation du balancement doux du fauteuil':'Faites glisser ou utilisez les flèches pour changer de point de vue');
      };
      motion.querySelector('[data-astra-motion-prev]')?.addEventListener('click',()=>{stop();show(index-1);});
      motion.querySelector('[data-astra-motion-next]')?.addEventListener('click',()=>{stop();show(index+1);});
      play?.addEventListener('click',togglePlay);
      modeButtons.forEach(button=>button.addEventListener('click',()=>setMode(button.dataset.astraMotionMode)));
      stage?.addEventListener('keydown',event=>{if(motion.classList.contains('is-rocking'))return;if(event.key==='ArrowLeft'){stop();show(index-1);}if(event.key==='ArrowRight'){stop();show(index+1);}});
      stage?.addEventListener('pointerdown',event=>{if(motion.classList.contains('is-rocking'))return;startX=event.clientX;stage.setPointerCapture?.(event.pointerId);});
      stage?.addEventListener('pointerup',event=>{if(motion.classList.contains('is-rocking')||startX===null)return;const distance=event.clientX-startX;startX=null;if(Math.abs(distance)>32){stop();show(index+(distance<0?1:-1));}});
      document.addEventListener('visibilitychange',()=>{if(document.hidden){stop();rockingVideo?.pause();}else if(motion.classList.contains('is-rocking') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){rockingVideo?.play().catch(()=>{});}});
      show(0);
    });
    // Link to the native form rather than duplicating variant/checkout logic.
    const sticky=root.querySelector('[data-astra-sticky]'), form=document.querySelector('.product-form__form');
    if(sticky && form && !sticky.dataset.ready){
      sticky.dataset.ready='true';
      const formId=form.getAttribute('id') || 'astra-product-form';
      form.setAttribute('id',formId);
      const button=sticky.querySelector('a'); button.href='#'+formId;
      button.addEventListener('click', () => {form.querySelector('button[type="submit"]')?.focus({preventScroll:true});});
      const observer=new IntersectionObserver(entries => { const e=entries[0]; sticky.hidden=e.isIntersecting || e.boundingClientRect.top>0; },{threshold:0}); observer.observe(form);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',()=>init());
})();
